import script from "./UserInformationTile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInformationTile.vue?vue&type=script&setup=true&lang=js"

export default script